import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Layout from './components/shared/Layout'
import Login from './components/Login'
import AttendanceManager from './components/attendance/clock-in-out/AttendanceManager'
import AttendanceLayout from './components/attendance/dtr/DailyTimeRecordLayout'
import ProtectedRoute from './helper/routes/ProtectedRoute'
import ReportComponent from './components/finance/ReportLayout'
import { UserProvider } from './helper/routes/UserContext'
import Unauthorized from './helper/UnauthorizedScreen'
import OTAttendanceManager from './components/attendance/ot/OTAttendanceManager'
import LeaveLayout from './components/attendance/leave/LeaveLayout'
import OvertimeRequestList from './components/management/OvertimeRequestList'
import QRAttendanceActions from './components/attendance/qr-scanner/QRAttendanceActions'
import EmployeeList from './components/employee/EmployeeList'
import EmployeeInfo from './components/employee/EmployeeInfo'
import UserRoleList from './components/role/UserRoleList'
import UserAccountList from './components/user-account/UserAccountList'
import UserAccountInfo from './components/user-account/UserAccountInfo'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import PositionList from './components/position/PositonList'
import WebAuthApp from './components/webauth/webauth'
import AuditLogList from './components/audit-logs/AuditLogList'
import MyProfile from './components/shared/profile/MyProfile'
import LeaveDetails from './components/attendance/leave/LeaveDetails'
import LeaveCalendarList from './components/attendance/leave/LeaveCalendarList'
import LeaveDetailNoAction from './components/attendance/leave/LeaveDetailsNoAction'
import ComingSoon from './components/attendance/leave/ComingSoonPage'
import LeaveEmployeeListLayout from './components/attendance/leave/leave_config/LeaveEmployeeListLayout'
import LeaveApprovedCalendarList from './components/attendance/leave/LeaveApprovedCalendarList'

function App() {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#d11919'
            },
            secondary: {
                main: '#0049db'
            }
        }
    })

    return (
        <UserProvider>
            <ThemeProvider theme={theme}>
                <Router>
                    <Routes>
                        <Route path="login" element={<Login />} /> {/* Public route */}
                        {/* <Route path="webAuthApp" element={<WebAuthApp />} /> 
                        <Route path="attendance/scan" element={<QRAttendanceActions />} />  */}
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route
                                index
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <AttendanceManager />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="attendance/dtr"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <AttendanceLayout />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="attendance/ot"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <OTAttendanceManager />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="attendance/leave"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <LeaveLayout />
                                        {/* <ComingSoon /> */}
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="leave/:leaveId"
                                element={
                                    <ProtectedRoute allowedRoles={['management', 'super admin', 'finance']}>
                                        <LeaveDetails />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="leave/details/:leaveId"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <LeaveDetailNoAction />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/leave/leave-approval"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'management', 'finance']}>
                                        <LeaveCalendarList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/leave/leave-approved"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'management', 'finance']}>
                                        <LeaveApprovedCalendarList />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="management/overtime-approval"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'management']}>
                                        <OvertimeRequestList />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="finance/generate-dtr"
                                element={
                                    <ProtectedRoute allowedRoles={['finance']}>
                                        <ReportComponent />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Protected route */}
                            <Route
                                path="employee"
                                element={
                                    <ProtectedRoute allowedRoles={['finance', 'super admin', 'management']}>
                                        <EmployeeList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="employee/info/:employeeId"
                                element={
                                    <ProtectedRoute allowedRoles={['finance', 'super admin', 'management']}>
                                        <EmployeeInfo />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="roles"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin']}>
                                        <UserRoleList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="user-account"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin']}>
                                        <UserAccountList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="account/info/:username"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin']}>
                                        <UserAccountInfo />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="audit-trail"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin']}>
                                        <AuditLogList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="profile/info"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'employee', 'finance', 'management']}>
                                        <MyProfile />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="leave/employee/list"
                                element={
                                    <ProtectedRoute allowedRoles={['super admin', 'finance', 'management']}>
                                        <LeaveEmployeeListLayout />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="positions" element={<PositionList />} /> {/* Public route */}
                        </Route>
                        <Route path="unauthorized" element={<Unauthorized />} /> {/* Display unauthorized message */}
                    </Routes>
                </Router>
            </ThemeProvider>
        </UserProvider>
    )
}

export default App
